import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useEffect } from "react";
import MainHome from "./Home/MainHome";
import Navbar from "./CommonComponents/Navbar";
import Footer from "./CommonComponents/Footer";
import ServicesMain from "./MainServices/ServicesMain";
import MainWhoandWhy from "./WhoandWhyMyrtle/MainWhoandWhy";
import MainBroadcast from "./Broadcasts/MainBroadcast";
import MainContactPage from "./ContactPage/MainContactPage";
import Admin from "./AdminPage/Admin";
import MainFromHome from "./FromHome/MainFromHome";
import ServicesMainPayers from "./MainServicesPayers/ServicesMainPayers";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top-left of the page
  }, [pathname]);

  return null;
};

function NavigationHandler() {}

function App() {
  return (
    <div className="App">
      <Navbar />
      <div className="content">
        <BrowserRouter>
          <ScrollToTop />
          <NavigationHandler />
          <Routes>
            <Route path="/" element={<MainHome />} />
            <Route path="/home" element={<MainHome />} />
            <Route path="/services" element={<ServicesMain />} />
            <Route path="/services/payers" element={<ServicesMainPayers />} />
            <Route path="/homeservices" element={<MainFromHome />} />
            <Route path="/whoandwhymyrtle" element={<MainWhoandWhy />} />
            <Route path="/broadcasts" element={<MainBroadcast />} />
            <Route path="/contactus" element={<MainContactPage />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>

        <Footer />
      </div>
    </div>
  );
}

export default App;
